import { Checkbox, Icon, Stack, TextInput } from "@/components"
import { useStyles } from "@/pages/campaign-form/components/campaigns/shareALink/Message.styles"
import { SingleColumnLayout } from "@/pages/campaign-form/components/layouts/SingleColumnLayout/SingleColumnLayout"
import { CampaignFormValues } from "@/pages/campaign-form/types"
import { urlInputValidation } from "app/static/frontend/forms/helperFunctions"
import React, { useEffect, useMemo } from "react"
import { useFormContext } from "react-hook-form"
import { TextInputWithCounter } from "@/components/TextInputWithCounter/TextInputWithCounter"

export const CAMPAIGN_SHARE_LINK_TYPE = "campaign"
export const LINK_SHARE_LINK_TYPE = "link"

const MAX_POST_LENGTH = 280
const MAX_POST_LENGTH_ERROR = `The message must be ${MAX_POST_LENGTH} characters or less.`
const { SocialMediaType } = DjangIO.app.grassroots.enums

export const Message = () => {
    const { classes } = useStyles()
    const formContext = useFormContext<CampaignFormValues>()
    const watchShareLinkType = formContext.watch("share_link_type") ?? LINK_SHARE_LINK_TYPE
    const socialMediaPlatforms = formContext.watch("social_media_platforms")
    const hasTwitterSelected = useMemo(
        () => socialMediaPlatforms?.includes(SocialMediaType.twitter.value),
        [socialMediaPlatforms],
    )

    const Layout = SingleColumnLayout

    useEffect(() => {
        if (watchShareLinkType === CAMPAIGN_SHARE_LINK_TYPE) {
            formContext.setValue("share_url", null)
        } else {
            formContext.setValue("share_campaign_link", null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchShareLinkType])

    const setDefaultMessage = () => {
        const posMessage = formContext.getValues("pos_message")
        if (!posMessage || posMessage === "") {
            const campaignName = formContext.getValues("name")
            const defaultMessage = `Thank you for supporting ${campaignName ? "the " + campaignName : "this"} campaign!`
            formContext.setValue("pos_message", defaultMessage)
        }
    }
    setDefaultMessage()

    return (
        <Layout>
            <div>
                <Checkbox.Group
                    name={"social_media_platforms"}
                    label="Choose platforms for sharing link"
                    transform={{
                        input: (input: string[] | number[]) => input?.map(String),
                        output: (output: string[]) => output?.map(Number),
                    }}
                    rules={{ required: "At least one social media should be selected" }}
                >
                    <Stack spacing="sm">
                        <Checkbox
                            value={SocialMediaType.facebook.value.toString()}
                            label={
                                <>
                                    <Icon icon="facebook" iconFamily="fab" className={classes.fbIcon} size="lg" />
                                    <span>Facebook</span>
                                </>
                            }
                        />
                        <Checkbox
                            value={SocialMediaType.linkedin.value.toString()}
                            label={
                                <>
                                    <Icon
                                        icon="linkedin-in"
                                        iconFamily="fab"
                                        className={classes.linkedinIcon}
                                        size="lg"
                                    />
                                    <span>LinkedIn</span>
                                </>
                            }
                        />
                        <Checkbox
                            value={SocialMediaType.twitter.value.toString()}
                            label={
                                <>
                                    <Icon icon="x-twitter" iconFamily="q" className={classes.xIcon} size="lg" />
                                    <span>X (Formerly Twitter)</span>
                                </>
                            }
                        />
                    </Stack>
                </Checkbox.Group>
                {/* CODE COMMENTED BECAUSE OF https://quorumanalytics.atlassian.net/browse/XE-279 */}
                {/* DO NOT REMOVE - WE WILL USE IT LATER */}
                {/* <div className={classes.linkTypeSection}>
                    <Text className={classes.title}>Select the type of link for sharing</Text>
                    <SegmentedControl
                        name="share_link_type"
                        data={[
                            { value: LINK_SHARE_LINK_TYPE, label: "Custom URL" },
                            { value: CAMPAIGN_SHARE_LINK_TYPE, label: "Campaign" },
                        ]}
                    />
                </div> */}
                {/* {watchShareLinkType === LINK_SHARE_LINK_TYPE && ( */}
                <TextInput
                    name="share_url"
                    label="Link"
                    tooltip='Choose the url that you would like your advocates to share on their social  media accounts. The header / image etc. will be automatically derived from the url that you choose. Make sure your url starts with "http://" or "https://".'
                    icon={<Icon icon="link" className={classes.linkIcon} />}
                    placeholder="Enter a link"
                    rules={{ required: "A link is required", validate: urlInputValidation }}
                />
                {/* )} */}
                {/* {watchShareLinkType === CAMPAIGN_SHARE_LINK_TYPE && (
                    <GenericSelect
                        SelectComponent={ActiveCampaignSelect}
                        name="share_campaign_link"
                        label="Select campaign link"
                        placeholder="Select a campaign"
                        model={Campaign}
                        multi={false}
                        withAsterisk
                    />
                )} */}
            </div>
            {hasTwitterSelected && (
                <TextInputWithCounter
                    name="pos_message"
                    label="Message"
                    tooltip="This message is only supported on X"
                    maxChars={MAX_POST_LENGTH}
                    rules={{
                        maxLength: { value: MAX_POST_LENGTH, message: MAX_POST_LENGTH_ERROR },
                    }}
                />
            )}
        </Layout>
    )
}
